// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/file-down.js';

import { paths } from '../generated/file-down';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('file-down', Original, paths);
